<kendo-appbar position="top">
    <kendo-appbar-spacer>
    </kendo-appbar-spacer>
    <kendo-appbar-section>
        <auth-badge></auth-badge>
    </kendo-appbar-section>
  <kendo-appbar-section>
    <button kendoButton (click)="this.showReleaseNotes()" [style]="{width: '150px', height: '40px' }" [svgIcon]="icon">Release notes</button>
  </kendo-appbar-section>
</kendo-appbar>
<div class="wrapper">
    <button kendoButton themeColor="primary" (click)="this.onNewKlant()" [style]="{width: '80px', innerHeight: '40px', margin: '8px'}">Nieuw</button>
    <kendo-grid [kendoGridBinding]="this.klanten" class="kendo-grid-custom" [filterable]="true" [sortable]="true"
        [pageable]="true" [pageSize]="30">
        <kendo-grid-column field="KLANTNO" title="Klant" [width]="200">
            <ng-template kendoGridCellTemplate let-dataItem>
                <a class="kop-link" routerLink="/SXB/{{dataItem.KLANTNO}}"
                    routerLinkActive="active">{{dataItem.KLANTNO}}</a>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="ACHTERNAAM" title="Achternaam">
        </kendo-grid-column>
        <kendo-grid-column field="VOORNAAM" title="Voornaam">
        </kendo-grid-column>
        <!-- <kendo-grid-column field="FULLNAAM" title="Naam">
        </kendo-grid-column> -->
        <kendo-grid-column field="NAAM" title="Dealer"></kendo-grid-column>
        <kendo-grid-column field="VERSIE_KOP" title="Versie"></kendo-grid-column>
        <kendo-grid-column field="KLANTNO" title="Edit" [filterable]="false" [width]="60" [maxResizableWidth]="60">
            <ng-template kendoGridCellTemplate let-dataItem>
                <button kendoButton (click)="this.onEditKlant(dataItem.KLANTNO)" [svgIcon]="this.editIcon"></button>
            </ng-template>
        </kendo-grid-column>

    </kendo-grid>
</div>
<div kendoDialogContainer></div>
